import { Component, OnInit } from '@angular/core';
import { PathNameService } from 'src/app/services/pathName/path-name.service';
declare var $:any;
@Component({
  selector: 'app-program',
  templateUrl: './program.component.html',
  styleUrls: ['./program.component.scss']
})
export class ProgramComponent implements OnInit {

  constructor(private pathNameService:PathNameService) { }

  ngOnInit(): void {
    $('.carousel').carousel({
      interval: 6000
    })
  }
  setUrl(route:string){
    this.pathNameService.setUrl(route);
  }

  admissionForm(id:number){

    if(id===1){
      window.open('https://data.odpay.in/odforms1/form/GNKCADMISSIONFORM/formperma/uxmt3lfNrhdUbxPbK1L3L-U_Pa7uqij8IlRi3HtRnog?zf_enablecamera=true');
    }
    if(id===2){
      window.open('https://data.odpay.in/odforms1/form/GNKCAdmissionEnquiryForm1/formperma/Pee7q1AnTeleOtJ333weAFWbGUzQijxP81hpxGbexfU');
    }
    if(id===3){
      window.open('https://apply.gnkc.ac.in/odforms/form/GURUNANAKKHALSACOLLEGE/formperma/yr4n3xJGKyT5zRio0XzJI7lOwLQ0-8jQ1nCj0P6RpZA');
    }
    if(id===4){
      window.open('https://data.odpay.in/odforms1/form/GNKRegistrationForm2025/formperma/50bLNsZljiXi9ZB32FeyrcKsre_DWo9p75ImqcofRI0');
    }
   
    $("#applyModal1").modal('hide');
  }
  closeModal(){
    $("#applyModal").modal('hide');
  }
}
